import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#ffdd00",
      primaryHover: "#e5c600",
    },
    logoImage: logo,
    backend: "https://e-handwerk.epaper-publishing-one.de/",
    header: {
      customer: "",
      lineHeader: true,
      title: "E-Handwerk",
    },
    directory: "/kiosk",
    info: [{
      text: 'Impressum',
      link: 'https://www.arge-medien-zveh.de/impressum'
    },
    {
    text: 'Datenschutz',
    link: 'https://www.arge-medien-zveh.de/datenschutzerklaerung'
  }],
  };